import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["template", "contacts", "addButton"];
  static values = {
    index: { type: Number, default: 0 },
  };

  connect() {
    // Count existing contacts to set the correct index
    const existingContacts = this.contactsTarget.querySelectorAll(
      ".emergency-contact-fields",
    );
    // Start at 1 if we have an initial contact, otherwise 0
    this.indexValue = existingContacts.length > 0 ? 1 : 0;

    // Show/hide add button based on contact count
    this.toggleAddButton();
  }

  add(event: Event) {
    event.preventDefault();

    // Get the template content
    const template = this.templateTarget.innerHTML;

    // Replace NEW_RECORD with a timestamp to ensure uniqueness
    const timestamp = new Date().getTime();
    const content = template.replace(/NEW_RECORD/g, timestamp.toString());

    // Insert the new contact fields
    this.contactsTarget.insertAdjacentHTML("beforeend", content);

    // Increment the index
    this.indexValue++;

    // Update button visibility
    this.toggleAddButton();

    // Focus on the first input of the new contact
    const newContact = this.contactsTarget.lastElementChild as HTMLElement;
    const firstInput = newContact?.querySelector("input") as HTMLInputElement;
    if (firstInput) {
      firstInput.focus();
    }
  }

  remove(event: Event) {
    event.preventDefault();

    const button = event.currentTarget as HTMLElement;
    const contactFields = button.closest(".emergency-contact-fields");

    if (contactFields) {
      // If this is an existing record, mark it for destruction
      const destroyInput = contactFields.querySelector(
        'input[name*="_destroy"]',
      ) as HTMLInputElement;

      if (destroyInput) {
        destroyInput.value = "1";
        contactFields.style.display = "none";
      } else {
        // If it's a new record, just remove it
        contactFields.remove();
      }
    }
  }
}
